import { useTranslation } from 'react-i18next'
import { usePostHog } from '@posthog/react'
import { NavArrowRightIcon } from '@/ui/icons/nav-arrow-right'
import { StarIcon } from '@/ui/icons/star'

interface ReturnRateProps {
  href: string
}

export const ReturnRate = ({ href }: ReturnRateProps) => {
  const { t } = useTranslation()

  const posthog = usePostHog()

  return (
    <div className="group relative flex w-full items-center gap-3 rounded-lg border border-neutral-300/50 bg-white p-5 shadow-sm transition-colors hover:bg-neutral-50">
      <span className="flex size-8 shrink-0 items-center justify-center rounded-md bg-neutral-100 text-neutral-700 transition-colors group-hover:bg-neutral-200">
        <StarIcon className="size-4" strokeWidth={1.5} />
      </span>
      <div className="min-w-0">
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          onClick={() => posthog?.capture('CSAT Clicked')}
          className="text-sm font-medium text-neutral-900 before:absolute before:inset-0 before:z-10"
        >
          {t('tracking_new.rate_title')}
        </a>
        <p className="text-xs font-normal text-neutral-600">
          {t('tracking_new.rate_subtitle')}
        </p>
      </div>
      <NavArrowRightIcon className="ml-auto size-4 shrink-0 text-neutral-500 transition-transform group-hover:translate-x-0.5 group-hover:text-neutral-700" />
    </div>
  )
}
